import { defaultHttpClient } from '../../httpClient';
import type { GetGoodsCouponResponse } from './type';

export const getGoodsCoupons = (
  goodsSno: number,
  fixedCouponSno?: number,
) => {
  return defaultHttpClient
    .request<GetGoodsCouponResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/coupons`,
      params: fixedCouponSno
        ? { fixed_coupon_sno: fixedCouponSno }
        : undefined,
    })
    .then(res => res.data);
};
